import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const IMG_BASE =
  "https://static.prod-images.emergentagent.com/jobs/c7daeff9-dc71-419e-8f04-11b938fd666e/images";

export const ASSETS = {
  hqMark: "/hqmark.png",
  hero: `${IMG_BASE}/e443b2afff827314500e14bda190a33b019d93e9a1274a71654c9c2e5abbbceb.jpeg`,
  slab: `${IMG_BASE}/a9cf876521ee3fcc5b09acdc58c4bb5893ccbe06312e2f5f53d8d59735637435.jpeg`,
  holoClean: `${IMG_BASE}/58a5d2b4c195c381b224f05ee9f699493ae276457f1916a06fca5bcb17fdd60b.jpeg`,
  labBg: `${IMG_BASE}/395128ebd579b2c967aecfc5f1454c97a9cc5ecdb288893bc8044fd6a5a7b142.jpeg`,
  circleLogo: "https://customer-assets-cm19k8pv.emergentagent.net/job_preview-cardhq/artifacts/r0voi0mj_image.png",
  madMax: "https://customer-assets-cm19k8pv.emergentagent.net/job_preview-cardhq/artifacts/mao0i9zh_file_000000001e1881f9b546c621677ce4ae.png",
  slabGriffey: "https://customer-assets-cm19k8pv.emergentagent.net/job_preview-cardhq/artifacts/qgnpu2fw_image.png",
  slabJordan: "https://customer-assets-cm19k8pv.emergentagent.net/job_preview-cardhq/artifacts/k33rmolh_image.png",
  comicAvengers4: "https://customer-assets-cm19k8pv.emergentagent.net/job_preview-cardhq/artifacts/zhofppoh_image.png",
  comicAction88: "https://static.prod-images.emergentagent.com/jobs/c7daeff9-dc71-419e-8f04-11b938fd666e/images/0218ec36daa31ac55b9d9572b280dc3153f12221f6cf9225ead833fe3f23f153.jpeg",
  comicCaptainAmerica1: "https://static.prod-images.emergentagent.com/jobs/c7daeff9-dc71-419e-8f04-11b938fd666e/images/d087daa46c54a293d278f58a38b15e52e8662a541acef8b429f558d548f49552.jpeg",
  cardsHero: "/cardshero.webp",
  privateVault: "https://static.prod-images.emergentagent.com/jobs/c7daeff9-dc71-419e-8f04-11b938fd666e/images/53017f9291924755736fb23364eff1e698df0d142a1b5131347fad41733b73f7.jpeg",
  careLabHero: "https://images.unsplash.com/photo-1708856034151-5de6269965bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx0cmFkaW5nJTIwY2FyZHMlMjBwcm90ZWN0aXZlJTIwc2xlZXZlcyUyMHN0b3JhZ2UlMjBhcmNoaXZhbHxlbnwwfHx8fDE3OTA3NTY0Mjl8MA&ixlib=rb-4.1.0&q=85",
  vaultHero: "https://static.prod-images.emergentagent.com/jobs/c7daeff9-dc71-419e-8f04-11b938fd666e/images/f3714808ab0d176b131004cc5c8e595baaaefc7bed0375ccae79b27b1fb0dcb2.jpeg",
};
